import React from "react";

const InputField = ({
  input,
  label,
  meta,
  placeholder,
  className,
  liveCheck,
  align,
}) => {
  const alignField = align ? align : "";
  const inValid =
    (meta.submitFailed || liveCheck) && meta.touched && meta.error;
  const inputClass = `${className} ${inValid ? "form-error" : ""}`;
  return (
    <div className={alignField}>
      <label className="input-label">{label}</label>
      <input className={inputClass} {...input} placeholder={placeholder} />
      <div className="input-error">{inValid ? meta.error : null}</div>
    </div>
  );
};

export default InputField;
